import React, { FC, useEffect, useRef, useState } from "react";

import { createUseStyles } from "react-jss";
import { ToastType } from "../../interface";
import {
  CONSTANTS,
} from "../../constants/globalVariable";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { getFeedbackToastStyle } from "../../constants/globalFunctions";
import { useDispatch, useSelector } from "react-redux";
import { TOAST_TYPE_SUCCESS } from "../../../services/constants";

const FeedbackToastComponent: FC<any> = ({ }: any) => {
  /******************* 
@Purpose : FeedbackToast Component
@Parameter : FeedbackToastComponentProps
@Author : Techture
 *******************/
  const refToast = useRef<any>(null);
  const dispatch = useDispatch()
  const toastNotificationContent: any = useSelector((state: any) => state.toastNotificationContent)

  const toastTitle: string = Object.keys(toastNotificationContent).length > 0 ? toastNotificationContent.title : "";

  const useStyles = createUseStyles({
    feedbackToast: getFeedbackToastStyle(toastTitle),
  });

  const classes = useStyles() as any;

  useEffect(() => {
    if (Object.keys(toastNotificationContent).length) {
      let type = toastNotificationContent?.type ? toastNotificationContent?.type : TOAST_TYPE_SUCCESS
      refToast?.current?.show({
        ...toastNotificationContent,
        icon: CONSTANTS.TOAST_ICON_TYPE_CLASSES[type as ToastType]?.CHILD,
        cssClass : `${CONSTANTS.TOAST_ICON_TYPE_CLASSES[type as ToastType]?.PARENT} ${classes.feedbackToast}`
      });
    }
  }, [toastNotificationContent]);

  return Object.keys(toastNotificationContent).length? (
    // TODO: This div prevents - Unable to removeChild from node error
    <div>
      <ToastComponent
        showProgressBar={true}
        ref={refToast}
        newestOnTop={false}
        buttons={
          toastNotificationContent?.isActionButton
            ? [
              {
                model: {
                  content: toastNotificationContent?.actionBtnText,
                },
                click: toastNotificationContent?.onActionBtnClick,
              },
            ]
            : []
        }
      />
    </div>
  ):'';
};
FeedbackToastComponent.defaultProps = {}
export default FeedbackToastComponent;
